import * as React from 'react'
import { Icon, Notification } from '../..'
import './order-notification.scss'
import { findUpcomingDeliveryDates } from './order-notification.utils'
import type { OrderNotificationsType } from './order-notification.utils'

// @IMPROVEMENT: Eventually these props should be passed to the component instead of grabbed from the window.
declare const orderNotifications: OrderNotificationsType

export class OrderNotification extends React.Component {
  render(): React.ReactNode {
    if (!orderNotifications?.length) {
      // Only show if we have active order information
      return null
    }

    const upcomingDeliveryDates = findUpcomingDeliveryDates(orderNotifications)

    if (!upcomingDeliveryDates.length) {
      return null
    }

    return (
      <Notification className='order-notification'>
        <Icon icon='truck' />
        <h2>Order Status</h2>
        {upcomingDeliveryDates.length === 1 ? (
          <p>
            Your upcoming order is confirmed for delivery on&nbsp;
            <strong>{upcomingDeliveryDates}</strong>
          </p>
        ) : (
          <p>
            Your upcoming orders are confirmed for delivery on&nbsp;
            <strong>{upcomingDeliveryDates.join(', ')}</strong>
          </p>
        )}
      </Notification>
    )
  }
}
